import React, { Component } from 'react';
import WidgetCard from './WidgetCard';

class Section extends Component {
  state = {};

  render() {
    const widgets = this.props.widgetsOrder.filter((widget) => widget.isDisplay);
    return (
      <React.Fragment>
        <div>
          {widgets.map((widget) => {
            return (
              <WidgetCard
                widget={widget}
                key={widget.id}
                triggerPreferenceThrottle={this.props.triggerPreferenceThrottle}
                updateWidgets={this.props.updateWidgets}
              />
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}

export default Section;
